<template>
  <form @submit="validate" novalidate="true">
    <div class="wrapper">
      <b-form class="col-md-12">
        <b-row v-if="others == 'applicant'">
          <b-col sm="12">
            <b-alert v-if="FormCompleted" show variant="primary">Bahagian ini telah lengkap. ✔</b-alert>
            <b-alert v-else show variant="warning">Bahagian ini tidak lengkap.</b-alert>
            <hr />
          </b-col>
        </b-row>
        <b-row v-if="others == 'father'">
          <b-col sm="12">
            <b-alert v-if="FormCompleted" show variant="primary">Bahagian ini telah lengkap. ✔</b-alert>
            <b-alert v-else show variant="warning">Bahagian ini tidak lengkap.</b-alert>
            <hr />
          </b-col>
        </b-row>
        <b-row v-if="others == 'mother'">
          <b-col sm="12">
            <b-alert v-if="FormCompleted" show variant="primary">Bahagian ini telah lengkap. ✔</b-alert>
            <b-alert v-else show variant="warning">Bahagian ini tidak lengkap.</b-alert>
            <hr />
          </b-col>
        </b-row>
        <b-row v-if="others == 'guardian'">
          <b-col sm="12">
            <b-alert v-if="FormCompleted" show variant="primary">Bahagian ini telah lengkap. ✔</b-alert>
            <b-alert v-else show variant="warning">Bahagian ini tidak lengkap.</b-alert>
            <hr />
          </b-col>
        </b-row>
        <b-row v-if="others == 'guarantor1'">
          <b-col sm="12">
            <b-alert v-if="FormCompleted" show variant="primary">Bahagian ini telah lengkap. ✔</b-alert>
            <b-alert v-else show variant="warning">Bahagian ini tidak lengkap.</b-alert>
            <hr />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group label-for="Email">
              <template v-slot:label>
                Emel
                <span v-if="others == 'applicant'" class="text-danger">
                  <span v-if="!IsEmailValid(Email)">*</span>
                  <span v-else>✔</span>
                </span>
              </template>
              <b-form-input type="email" placeholder="Cth: pelajar@google.com" autocomplete="email"
                :disabled="Busy == true || Submitted == true" v-model.trim="Email"></b-form-input>
              <span class="error" v-show="Email && !IsEmailValid(Email)">
                <span style="color: red">Alamat emel tidak sah.</span>
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="others == 'applicant'">
          <b-col sm="6">
            <b-alert v-if="Email && IsEmailValid(Email)" show variant="primary">Pastikan anda menggunakan alamat emel yang
              aktif.</b-alert>
            <b-alert v-else show variant="warning">Pastikan anda menggunakan alamat emel yang aktif.</b-alert>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col sm="6">
            <b-form-group label-for="fixPhone">
              <template v-slot:label>
                Nombor Telefon Rumah
                <span v-if="others == 'applicant' || others == 'father' || others == 'mother' || others == 'guardian'" class="text-danger">
                  <span v-if="!FixPhoneNo" class="text-danger">*</span>
                  <span v-else>✔</span>
                </span>
              </template>
              <b-form-input placeholder="Cth: 0340526617" :disabled="Busy == true || Submitted == true"
                v-model.trim="FixPhoneNo" maxlength="12"
                @keyup="replaceDash()"
                @change="replaceDash()"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label-for="mobilePhone">
              <template v-slot:label>
                Telefon (Bimbit)
                <span v-if="others == 'applicant' || others == 'father' || others == 'mother' || others == 'guardian'" class="text-danger">
                  <span v-if="!MobilePhoneNo" class="text-danger">*</span>
                  <span v-else>✔</span>
                </span>
              </template>
              <b-form-input placeholder="Cth: 0134052667" :disabled="Busy == true || Submitted == true"
                v-model.trim="MobilePhoneNo" maxlength="12"
                @keyup="replaceDash()"
                @change="replaceDash()"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <!--Add New Label for Phone Number and Home Number #cm4 MILRAD-->
        <b-row v-if="others == 'applicant' && (!FixPhoneNo || !MobilePhoneNo)">
          <b-col sm="6">
            <b-alert v-if="!FixPhoneNo || !MobilePhoneNo" show variant="warning">Wajib isi kedua - dua nya sekali (Jika tiada no telefon rumah sila isi no telefon bimbit di medan no telefon rumah)</b-alert>
          </b-col>
        </b-row>
        <b-row v-if="others == 'father' && (!FixPhoneNo || !MobilePhoneNo)">
          <b-col sm="6">
            <b-alert v-if="!FixPhoneNo || !MobilePhoneNo" show variant="warning">Wajib isi kedua - dua nya sekali (Jika tiada no telefon rumah sila isi no telefon bimbit di medan no telefon rumah)</b-alert>
          </b-col>
        </b-row>
        <b-row v-if="others == 'mother' && (!FixPhoneNo || !MobilePhoneNo)">
          <b-col sm="6">
            <b-alert v-if="!FixPhoneNo || !MobilePhoneNo" show variant="warning">Wajib isi kedua - dua nya sekali (Jika tiada no telefon rumah sila isi no telefon bimbit di medan no telefon rumah)</b-alert>
          </b-col>
        </b-row>
        <b-row v-else-if="others == 'guarantor1' && (!FixPhoneNo || !MobilePhoneNo)">
          <b-col sm="6">
            <b-alert v-if="!FixPhoneNo || !MobilePhoneNo" show variant="warning">Wajib isi kedua - dua nya sekali (Jika tiada no telefon rumah sila isi no telefon bimbit di medan no telefon rumah)</b-alert>
          </b-col>
        </b-row>
        <b-row v-else-if="others == 'guarantor2' && (!FixPhoneNo || !MobilePhoneNo)">
          <b-col sm="6">
            <b-alert v-if="!FixPhoneNo || !MobilePhoneNo" show variant="warning">Wajib isi kedua - dua nya sekali (Jika tiada no telefon rumah sila isi no telefon bimbit di medan no telefon rumah)</b-alert>
          </b-col>
        </b-row>
        <b-row v-else-if="others == 'guardian' && (!FixPhoneNo || !MobilePhoneNo)">
          <b-col sm="6">
            <b-alert v-if="!FixPhoneNo || !MobilePhoneNo" show variant="warning">Wajib isi kedua - dua nya sekali (Jika tiada no telefon rumah sila isi no telefon bimbit di medan no telefon rumah)</b-alert>
          </b-col>
        </b-row>
        <!--Add New Label for Phone Number and Home Number #cm4 MILRAD-->
        <hr />
        <b-row>
          <b-col sm="6">
            <div v-if="others == 'applicant'">
              <p class="lead">
                Alamat Tetap
                <!-- <span v-if="AddressId == 0" class="text-danger">*</span>
                <span v-else>✔</span> -->
                <span v-if="Address1 == 0 || Address2 == 0 || Postcode == 0" class="text-danger">*</span>
                <span v-else>✔</span>
              </p>
              <b-alert v-if="AddressId == 0" show variant="warning">Sila klik butang kemaskini untuk tambahan atau
                pertukaran
                alamat.</b-alert>
            </div>
            <div v-else-if="others == 'spouse'">
              <p class="lead">
                Alamat
              </p>
              <b-alert v-if="AddressId == 0" show variant="warning">Sila klik butang kemaskini untuk tambahan atau
                pertukaran
                alamat.</b-alert>
            </div>
            <div v-else>
              <!-- Keep for easy troubleshooting
              {{AddressId}}
              <br>
              R = {{RelationshipId}}
              <br>
              R4 = {{RelationshipIdV4}}
              <br>
              others = {{others}}
              <br>
              -->
              <p class="lead">
                Alamat
                <span v-if="AddressId == 0 || Address1 == 0 || Address2 == 0 || Postcode == 0 || Address1 == '' || Address2 == '' || Postcode == ''" class="text-danger">*</span>
                <span v-else>✔</span>
              </p>
              <b-alert v-if="AddressId == 0" show variant="warning">Sila klik butang kemaskini untuk tambahan atau pertukaran alamat.</b-alert>
            </div>
          </b-col>
          <b-col sm="6">
            <div class="float-right">
              <b-dropdown :disabled="Busy == true || Submitted == true" v-bind:id="others + 'ddown'" text="Kemaskini"
                class="m-2" variant="primary">
                <template v-if="others == 'applicant'">
                  <b-dropdown-item @click="SetTypePermanent">Tambah</b-dropdown-item>
                  <template v-if="AddressId != 0">
                    <b-dropdown-item @click="(editAddressModal = true), (type = 'permanent')">Edit</b-dropdown-item>
                  </template>
                  <b-dropdown-item @click="(chooseAddressModal = true), (type = 'permanent')">Pilih</b-dropdown-item>
                </template>
                <template v-else>
                  <b-dropdown-item @click="SetTypePersonal">Tambah</b-dropdown-item>
                  <template v-if="AddressId != 0">
                    <b-dropdown-item @click="(editAddressModal = true), (type = 'personal')">Edit</b-dropdown-item>
                  </template>
                  <b-dropdown-item @click="(chooseAddressModal = true), (type = 'personal')">Pilih</b-dropdown-item>
                </template>
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="AddressId != 0">
          <b-col sm="6">
<!--
{{AddressId}}
<br>
R = {{RelationshipId}}
<br>
R4 = {{RelationshipIdV4}}
<br>
others = {{others}}
-->
            <span>
              <div>
                <template v-if="Address1 != ''">{{ Address1 }},</template>
                <template v-if="Address2 != ''">{{ Address2 }},</template>
                <template v-if="Address3 != ''">{{ Address3 }},</template>
              </div>
              <div>
                <template v-if="Postcode != ''">{{ Postcode }},</template>
                <template v-if="CountryId == 130">
                  <template v-if="CityName != ''">{{ CityName }},
                    <br />
                  </template>
                  <template v-if="StateName != ''">{{ StateName }},</template>
                </template>
                <template v-else>
                  <template v-if="OtherStateName != ''">{{ OtherStateName }},</template>
                </template>
                <template v-if="CountryName != ''">{{ CountryName }}</template>
              </div>
            </span>
          </b-col>
        </b-row>
        <div v-if="others == 'applicant'">
          <hr />
          <b-row>
            <b-col sm="6">
              <p class="lead">
                Alamat Surat-menyurat
                <span v-if="MailAddressId == 0" class="text-danger">*</span>
                <span v-else>✔</span>
              </p>
              <b-alert v-if="MailAddressId == 0" show variant="warning">Sila klik butang kemaskini untuk tambahan atau
                pertukaran
                alamat.</b-alert>
            </b-col>
            <b-col sm="6">
              <div class="float-right">
                <b-dropdown :disabled="Busy == true || Submitted == true" v-bind:id="others + 'ddownMail'"
                  text="Kemaskini" class="m-2" variant="primary">
                  <b-dropdown-item @click="SetTypeMail">Tambah</b-dropdown-item>
                  <template v-if="MailAddressId != 0">
                    <b-dropdown-item @click="(editAddressModal = true), (type = 'mail')">Edit</b-dropdown-item>
                  </template>
                  <b-dropdown-item @click="(chooseAddressModal = true), (type = 'mail')">Pilih</b-dropdown-item>
                </b-dropdown>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="MailAddressId != 0">
            <b-col sm="6">
              <span>
                <div>
                  <template v-if="MailAddress1 != ''">{{ MailAddress1 }},</template>
                  <template v-if="MailAddress2 != ''">{{ MailAddress2 }},</template>
                  <template v-if="MailAddress3 != ''">{{ MailAddress3 }},</template>
                </div>
                <div>
                  <template v-if="MailPostcode != ''">{{ MailPostcode }},</template>
                  <template v-if="MailCountryId == 130">
                    <template v-if="MailCityId > 0">{{ MailCityName }},
                      <br />
                    </template>
                    <template v-if="MailStateId > 0">{{ MailStateName }},</template>
                  </template>
                  <template v-else>
                    <template v-if="MailOtherStateName != ''">{{ MailOtherStateName }},
                      <br />
                    </template>
                  </template>
                  <template v-if="MailCountryId > 0">{{ MailCountryName }}</template>
                </div>
              </span>
            </b-col>
          </b-row>
        </div>
      </b-form>
      <!-- Modal Component -->
      <b-modal title="Tambah Alamat Baru" variant="primary" header-bg-variant="primary"
        :disabled="Busy == true || Submitted == true" v-model="addAddressModal" @ok="InsertAddress">
        <AddressBook type="insert" />
      </b-modal>
      <b-modal title="Edit Alamat" variant="primary" header-bg-variant="primary"
        :disabled="Busy == true || Submitted == true" v-model="editAddressModal" @ok="UpdateAddress">
        <template v-if="others == 'applicant'">
          <template v-if="type == 'permanent'">
            <AddressBook type="applicant" others="permanent" />
          </template>
          <template v-else>
            <AddressBook type="applicant" others="mail" />
          </template>
        </template>
        <template v-else-if="others == 'spouse'">
          <AddressBook type="personal" others="spouse" />
        </template>
        <template v-else-if="others == 'father'">
          <AddressBook type="personal" others="father" />
        </template>
        <template v-else-if="others == 'mother'">
          <AddressBook type="personal" others="mother" />
        </template>
        <template v-else-if="others == 'guardian'">
          <AddressBook type="personal" others="guardian" />
        </template>
        <template v-else-if="others == 'family'">
          <AddressBook type="personal" others="family" />
        </template>
        <template v-else-if="others == 'guarantor1'">
          <AddressBook type="personal" others="guarantor1" />
        </template>
        <template v-else-if="others == 'guarantor2'">
          <AddressBook type="personal" others="guarantor2" />
        </template>
      </b-modal>
      <b-modal title="Pilih Alamat" variant="primary" header-bg-variant="primary"
        :disabled="Busy == true || Submitted == true" v-model="chooseAddressModal" @ok="ChangeAddress">
        <AddressList />
      </b-modal>
    </div>
  </form>
</template>
<script>
import DefaultOption from "./DefaultOption";
import AddressBook from "./AddressBook";
import AddressList from "./AddressList";

export default {
  name: "ContactDetails",
  props: ["others"],
  components: {
    DefaultOption,
    AddressBook,
    AddressList,
  },
  data: function () {
    return {
      addAddressModal: false,
      editAddressModal: false,
      chooseAddressModal: false,
      type: "",
      AddressBooks: {},
      sCFN: 'ContactDetails: ',
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.AddressId = 0;
      this.GetContactDetails();

      if (this.others == "applicant") {
        this.GetAddressPermanent();
        this.GetAddressMail();
      } else {
        await this.GetAddressPersonal(this.others);
      }
      this.FormCompleted; // force to compute FormCompleted upon mount
    }
  },
  computed: {
    FormCompleted: {
      get: function () {
        let fN = 'FormCompleted: ';
        let complete = true;
        if (this.others == "applicant") {
          if (
            !this.Email ||
            this.Address1 == 0 ||
            this.Address2 == 0 ||
            this.Postcode == 0 ||
            this.MailAddressId == 0
          ) {
            complete = false;
          }
          if (!this.MobilePhoneNo && !this.FixPhoneNo) complete = false;

          this.$store.dispatch(
            "appContactDetails/updateFormCompleted",
            complete
          );
          return complete;
        } else if (this.others == "father") {
          //this.HTECHLogger(this.sCFN + fN + 'this.others = father')
          //this.HTECHLogger(this.sCFN + fN + 'A1 = ' + this.Address1 + ' | A2 = ' + this.Address2 + ' | A3 = ' + this.Address3)
          if (this.Address1 == 0 || this.Address2 == 0 || this.Postcode == 0) {
            complete = false;
          }
          if (0 == this.MobilePhoneNo.length || 0 == this.FixPhoneNo.length) complete = false;
          this.$store.dispatch(
            "fatherContactDetails/updateFormCompleted",
            complete
          );

          return complete;
        } else if (this.others == "mother") {
          if (this.Address1 == 0 || this.Address2 == 0 || this.Postcode == 0) {
            complete = false;
          }
          if (0 == this.MobilePhoneNo.length || 0 == this.FixPhoneNo.length) complete = false;
          this.$store.dispatch(
            "motherContactDetails/updateFormCompleted",
            complete
          );

          return complete;
        } else if (this.others == "guardian") {
          if (this.Address1 == 0 || this.Address2 == 0 || this.Postcode == 0) {
            complete = false;
          }
          if (0 == this.MobilePhoneNo.length || 0 == this.FixPhoneNo.length) complete = false;
          this.$store.dispatch(
            "guardianContactDetails/updateFormCompleted",
            complete
          );

          return complete;
        } else if (this.others == "guarantor1") {
          if (0 == this.MobilePhoneNo.length || 0 == this.FixPhoneNo.length) complete = false;
          if (this.Address1 == 0 || this.Address2 == 0 || this.Postcode == 0) {
            complete = false;
          }
          this.$store.dispatch(
            "guarantor1ContactDetails/updateFormCompleted",
            complete
          );
          return complete;
        } else if (this.others == "guarantor2") {
          if (this.Address1 == 0 || this.Address2 == 0 || this.Postcode == 0) {
            complete = false;
          }
          if (0 == this.MobilePhoneNo.length || 0 == this.FixPhoneNo.length) complete = false;
          this.$store.dispatch(
            "guarantor2ContactDetails/updateFormCompleted",
            complete
          );
          return complete;
        }
      },
    },
    Busy: {
      get: function () {
        return this.$store.getters["common/Busy"];
      },
      set: function (value) {
        this.$store.dispatch("common/updateBusy", value);
      },
    },
    Submitted: {
      get: function () {
        return this.$store.getters["common/Submitted"];
      },
    },
    RelationshipId: {
      get: function () {
        return this.$store.getters["appPersonalDetails/Relationship"];
      },
      set: function (value) {
        this.$store.dispatch("appPersonalDetails/updateRelationship", value);
      },
    },
    ContactModule: {
      get: function () {
        if (this.others == "applicant") return "appContactDetails";
        else return this.others + "ContactDetails";
      },
    },
    AddressId: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/Id"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalAddressId;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalAddressId;
          }
          return this.$store.getters[this.others + "PersonalAddress/Id"];
        }
      },
      set: function (value) {
        if (this.others == "applicant") {
          this.$store.dispatch("appPermanentAddress/updateId", value);
        } else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalAddress", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalAddress", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateId", value);
          }
        }
      },
    },
    Address1: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/Address1"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalAddress1;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalAddress1;
          }
          return this.$store.getters[this.others + "PersonalAddress/Address1"];
        }
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updateAddress1", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalAddress1", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalAddress1", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateAddress1", value);
          }
        }
      },
    },
    Address2: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/Address2"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalAddress2;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalAddress2;
          }
          return this.$store.getters[this.others + "PersonalAddress/Address2"];
        }
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updateAddress2", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalAddress2", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalAddress2", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateAddress2", value);
          }
        }
      },
    },
    Address3: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/Address3"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalAddress3;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalAddress3;
          }
          return this.$store.getters[this.others + "PersonalAddress/Address3"];
        }
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updateAddress3", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalAddress3", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalAddress3", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateAddress3", value);
          }
        }
      },
    },
    Postcode: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/Postcode"];
        else 
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalPostcode;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalPostcode;
          }
          return this.$store.getters[this.others + "PersonalAddress/Postcode"];
        }
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updatePostcode", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalPostcode", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalPostcode", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updatePostcode", value);
          }
        }
      },
    },
    CityId: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/City"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalCityId;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalCityId;
          }
          return this.$store.getters[this.others + "PersonalAddress/CityId"];
        }
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updateCity", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalCityId", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalCityId", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateCity", value);
          }
        }
      },
    },
    StateId: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/StateId"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalStateId;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalStateId;
          }
        }
        return this.$store.getters[this.others + "PersonalAddress/StateId"];
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updateState", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalStateId", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalStateId", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateState", value);
          }
        }
      },
    },
    CountryId: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/CountryId"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalCountryId;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalCountryId;
          }
        }
        return this.$store.getters[this.others + "PersonalAddress/CountryId"];
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updateCountry", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalCountryId", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalCountryId", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateCountry", value);
          }
        }
      },
    },
    CityName: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/CityName"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalCityName;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalCityName;
          }
        }
        return this.$store.getters[this.others + "PersonalAddress/CityName"];
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updateCityName", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalCityName", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalCityName", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateCityName", value);
          }
        }
      },
    },
    StateName: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/StateName"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalStateName;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalStateName;
          }
        }
        return this.$store.getters[this.others + "PersonalAddress/StateName"];
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updateStateName", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalStateName", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalStateName", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateStateName", value);
          }
        }
      },
    },
    OtherStateName: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/OtherStateName"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalOtherStateName;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalOtherStateName;
          }
        }
        return this.$store.getters[this.others + "PersonalAddress/OtherStateName"];
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updateOtherStateName", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalOtherStateName", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalOtherStateName", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateOtherStateName", value);
          }
        }
      },
    },
    CountryName: {
      get: function () {
        if (this.others == "applicant")
          return this.$store.getters["appPermanentAddress/CountryName"];
        else
        {
          if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
            return this.MotherPersonalCountryName;
          }
          if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
            return this.FatherPersonalCountryName;
          }
        }
        return this.$store.getters[this.others + "PersonalAddress/CountryName"];
      },
      set: function (value) {
        if (this.others == "applicant")
          this.$store.dispatch("appPermanentAddress/updateCountryName", value);
        else {
          if (16 == this.RelationshipIdV4) {
            this.$store.dispatch("motherPersonalDetails/updatePersonalCountryName", value);
          } else if (17 == this.RelationshipIdV4) {
            this.$store.dispatch("fatherPersonalDetails/updatePersonalCountryName", value);
          } else {
            this.$store.dispatch(this.others + "PersonalAddress/updateCountryName", value);
          }
        }
      },
    },

    // address
    MailAddressId: {
      get: function () {
        return this.$store.getters["appMailAddress/Id"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateId", value);
      },
    },
    MailAddress1: {
      get: function () {
        return this.$store.getters["appMailAddress/Address1"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateAddress1", value);
      },
    },
    MailAddress2: {
      get: function () {
        return this.$store.getters["appMailAddress/Address2"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateAddress2", value);
      },
    },
    MailAddress3: {
      get: function () {
        return this.$store.getters["appMailAddress/Address3"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateAddress3", value);
      },
    },
    MailPostcode: {
      get: function () {
        return this.$store.getters["appMailAddress/Postcode"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updatePostcode", value);
      },
    },
    MailCityId: {
      get: function () {
        return this.$store.getters["appMailAddress/CityId"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateCity", value);
      },
    },
    MailStateId: {
      get: function () {
        return this.$store.getters["appMailAddress/StateId"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateState", value);
      },
    },
    MailCountryId: {
      get: function () {
        return this.$store.getters["appMailAddress/CountryId"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateCountry", value);
      },
    },
    MailCityName: {
      get: function () {
        return this.$store.getters["appMailAddress/CityName"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateCityName", value);
      },
    },
    MailStateName: {
      get: function () {
        return this.$store.getters["appMailAddress/StateName"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateStateName", value);
      },
    },
    MailOtherStateName: {
      get: function () {
        return this.$store.getters["appMailAddress/OtherStateName"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateOtherStateName", value);
      },
    },
    MailCountryName: {
      get: function () {
        return this.$store.getters["appMailAddress/CountryName"];
      },
      set: function (value) {
        this.$store.dispatch("appMailAddress/updateCountryName", value);
      },
    },
    // Address
    SelectedId: {
      get: function () {
        return this.$store.getters["addressBook/SelectedId"];
      },
      set: function (value) {
        this.$store.dispatch("addressBook/updateSelectedId", value);
      },
    },
    // Contact Details
    Email: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherContactInfo.Email;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherContactInfo.Email;
        }
        return this.$store.getters[this.ContactModule + "/Email"];
      },
      set: function (value) {
        if (16 == this.RelationshipIdV4) {
          this.$store.dispatch("motherContactDetails/updateEmail", value);
        } else if (17 == this.RelationshipIdV4) {
          this.$store.dispatch("fatherContactDetails/updateEmail", value);
        } else {
          this.$store.dispatch(this.ContactModule + "/updateEmail", value);
        }
      },
    },
    FixPhoneNo: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherContactInfo.FixPhoneNo;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherContactInfo.FixPhoneNo;
        }
        return this.$store.getters[this.ContactModule + "/FixPhoneNo"];
      },
      set: function (value) {
        if (16 == this.RelationshipIdV4) {
          this.$store.dispatch("motherContactDetails/updateFixPhoneNo", value);
        } else if (17 == this.RelationshipIdV4) {
          this.$store.dispatch("fatherContactDetails/updateFixPhoneNo", value);
        } else {
          this.$store.dispatch(this.ContactModule + "/updateFixPhoneNo", value);
        }
      },
    },
    MobilePhoneNo: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherContactInfo.MobilePhoneNo;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherContactInfo.MobilePhoneNo;
        }
        return this.$store.getters[this.ContactModule + "/MobilePhoneNo"];
      },
      set: function (value) {
        if (16 == this.RelationshipIdV4) {
          this.$store.dispatch("motherContactDetails/updateMobilePhoneNo", value);
        } else if (17 == this.RelationshipIdV4) {
          this.$store.dispatch("fatherContactDetails/updateMobilePhoneNo", value);
        } else {
          this.$store.dispatch(this.ContactModule + "/updateMobilePhoneNo", value);
        }
      },
    },
    FaxNo: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherContactInfo.FaxNo;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherContactInfo.FaxNo;
        }
        return this.$store.getters[this.ContactModule + "/FaxNo"];
      },
      set: function (value) {
        if (16 == this.RelationshipIdV4) {
          this.$store.dispatch("motherContactDetails/updateFaxNo", value);
        } else if (17 == this.RelationshipIdV4) {
          this.$store.dispatch("fatherContactDetails/updateFaxNo", value);
        } else {
          this.$store.dispatch(this.ContactModule + "/updateFaxNo", value);
        }
      },
    },
    //////
    RelationshipIdV4: {
      get: function() {
        return this.$store.getters["appPersonalDetails/RelationshipV4"];
      },
      set: function(value) {
        this.$store.dispatch("appPersonalDetails/updateRelationshipV4", value);
      }
    },
    FatherDetailsFormCompleted: {
      get: function() {
        return this.$store.getters["fatherContactDetails/FormCompleted"];
      }
    },
    FatherContactInfo: {
      get: function() {
        let obj = {};
        obj.FixPhoneNo = this.$store.getters["fatherContactDetails/FixPhoneNo"];
        obj.MobilePhoneNo = this.$store.getters["fatherContactDetails/MobilePhoneNo"];
        obj.FaxNo = this.$store.getters["fatherContactDetails/FaxNo"];
        obj.Email = this.$store.getters["fatherContactDetails/Email"];
        obj.NationalityId = this.$store.getters["fatherPersonalDetails/Nationality"];
        return obj;
      },
    },
    FatherPersonalAddressId: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalAddress"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalAddress", value);
      }
    },
    FatherPersonalAddress1: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalAddress1"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalAddress1", value);
      }
    },
    FatherPersonalAddress2: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalAddress2"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalAddress2", value);
      }
    },
    FatherPersonalAddress3: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalAddress3"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalAddress3", value);
      }
    },
    FatherPersonalPostcode: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalPostcode"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalPostcode", value);
      }
    },
    FatherPersonalCityId: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalCityId"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalCityId", value);
      }
    },
    FatherPersonalCityName: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalCityName"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalCityName", value);
      }
    },
    FatherPersonalStateId: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalStateId"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalStateId", value);
      }
    },
    FatherPersonalStateName: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalStateName"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalStateName", value);
      }
    },
    FatherPersonalOtherStateName: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalOtherStateName"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalOtherStateName", value);
      }
    },
    FatherPersonalCountryId: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalCountryId"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalCountryId", value);
      }
    },
    FatherPersonalCountryName: {
      get: function() {
        return this.$store.getters["fatherPersonalDetails/PersonalCountryName"];
      },
      set: function(value) {
        this.$store.dispatch("fatherPersonalDetails/updatePersonalCountryName", value);
      }
    },
    MotherDetailsFormCompleted: {
      get: function() {
        return this.$store.getters["motherContactDetails/FormCompleted"];
      }
    },
    MotherContactInfo: {
      get: function() {
        let obj = {};
        obj.FixPhoneNo = this.$store.getters["motherContactDetails/FixPhoneNo"];
        obj.MobilePhoneNo = this.$store.getters["motherContactDetails/MobilePhoneNo"];
        obj.FaxNo = this.$store.getters["motherContactDetails/FaxNo"];
        obj.Email = this.$store.getters["motherContactDetails/Email"];
        obj.NationalityId = this.$store.getters["motherPersonalDetails/Nationality"];
        return obj;
      },
    },
    MotherPersonalAddressId: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalAddress"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalAddress", value);
      }
    },
    MotherPersonalAddress1: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalAddress1"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalAddress1", value);
      }
    },
    MotherPersonalAddress2: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalAddress2"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalAddress2", value);
      }
    },
    MotherPersonalAddress3: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalAddress3"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalAddress3", value);
      }
    },
    MotherPersonalPostcode: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalPostcode"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalPostcode", value);
      }
    },
    MotherPersonalCityId: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalCityId"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalCityId", value);
      }
    },
    MotherPersonalCityName: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalCityName"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalCityName", value);
      }
    },
    MotherPersonalStateId: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalStateId"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalStateId", value);
      }
    },
    MotherPersonalStateName: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalStateName"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalStateName", value);
      }
    },
    MotherPersonalOtherStateName: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalOtherStateName"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalOtherStateName", value);
      }
    },
    MotherPersonalCountryId: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalCountryId"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalCountryId", value);
      }
    },
    MotherPersonalCountryName: {
      get: function() {
        return this.$store.getters["motherPersonalDetails/PersonalCountryName"];
      },
      set: function(value) {
        this.$store.dispatch("motherPersonalDetails/updatePersonalCountryName", value);
      }
    },
  },
  methods: {
    validate(e) {
      if (!this.$v.valid) {
        e.preventDefault();
        alert("not valid!");
      }
    },
    async GetAddressPersonal(others) {
      return this.$API
        .get(this.$PersonalAddress + "/" + others, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.AddressId = this.info.Id;
            this.Address1 = null != this.info.Address1 ? this.info.Address1.toUpperCase() : this.info.Address1;
            this.Address2 = null != this.info.Address2 ? this.info.Address2.toUpperCase() : this.info.Address2;
            this.Address3 = null != this.info.Address3 ? this.info.Address3.toUpperCase() : this.info.Address3;
            this.Postcode = null != this.info.Postcode ? this.info.Postcode.toUpperCase() : this.info.Postcode;
            this.CityId = this.info.CityId;
            this.CityName = null != this.info.CityName ? this.info.CityName.toUpperCase() : this.info.CityName;
            this.StateId = this.info.StateId;
            this.StateName = null != this.info.StateName ? this.info.StateName.toUpperCase() : this.info.StateName;
            this.OtherStateName = null != this.info.OtherStateName ? this.info.OtherStateName.toUpperCase() : this.info.OtherStateName;
            this.CountryId = this.info.CountryId;
            this.CountryName = null != this.info.CountryName ? this.info.CountryName.toUpperCase() : this.info.CountryName;

            if ('father' === others) {
              this.FatherPersonalAddressId = this.info.Id;
              this.FatherPersonalAddress1 = null != this.info.Address1 ? this.info.Address1.toUpperCase() : this.info.Address1;
              this.FatherPersonalAddress2 = null != this.info.Address2 ? this.info.Address2.toUpperCase() : this.info.Address2;
              this.FatherPersonalAddress3 = null != this.info.Address3 ? this.info.Address3.toUpperCase() : this.info.Address3;
              this.FatherPersonalPostcode = null != this.info.Postcode ? this.info.Postcode.toUpperCase() : this.info.Postcode;
              this.FatherPersonalCityId = this.info.CityId;
              this.FatherPersonalCityName = null != this.info.CityName ? this.info.CityName.toUpperCase() : this.info.CityName;
              this.FatherPersonalStateId = this.info.StateId;
              this.FatherPersonalStateName = null != this.info.StateName ? this.info.StateName.toUpperCase() : this.info.StateName;
              this.FatherPersonalOtherStateName = null != this.info.OtherStateName ? this.info.OtherStateName.toUpperCase() : this.info.OtherStateName;
              this.FatherPersonalCountryId = this.info.CountryId;
              this.FatherPersonalCountryName = null != this.info.CountryName ? this.info.CountryName.toUpperCase() : this.info.CountryName;
            }
            if ('mother' === others) {
              this.MotherPersonalAddressId = this.info.Id;
              this.MotherPersonalAddress1 = null != this.info.Address1 ? this.info.Address1.toUpperCase() : this.info.Address1;
              this.MotherPersonalAddress2 = null != this.info.Address2 ? this.info.Address2.toUpperCase() : this.info.Address2;
              this.MotherPersonalAddress3 = null != this.info.Address3 ? this.info.Address3.toUpperCase() : this.info.Address3;
              this.MotherPersonalPostcode = null != this.info.Postcode ? this.info.Postcode.toUpperCase() : this.info.Postcode;
              this.MotherPersonalCityId = this.info.CityId;
              this.MotherPersonalCityName = null != this.info.CityName ? this.info.CityName.toUpperCase() : this.info.CityName;
              this.MotherPersonalStateId = this.info.StateId;
              this.MotherPersonalStateName = null != this.info.StateName ? this.info.StateName.toUpperCase() : this.info.StateName;
              this.MotherPersonalOtherStateName = null != this.info.OtherStateName ? this.info.OtherStateName.toUpperCase() : this.info.OtherStateName;
              this.MotherPersonalCountryId = this.info.CountryId;
              this.MotherPersonalCountryName = null != this.info.CountryName ? this.info.CountryName.toUpperCase() : this.info.CountryName;
            }
            if (this.AddressId == null) this.AddressId = 0;
            if (this.Address1 == null) this.Address1 = "";
            if (this.Address2 == null) this.Address2 = "";
            if (this.Address3 == null) this.Address3 = "";
            if (this.Postcode == null) this.Postcode = "";
            if (this.CityName == null) this.CityName = "";
            if (this.StateName == null) this.StateName = "";
            if (this.OtherStateName == null) this.OtherStateName = "";
            if (this.CountryName == null) this.CountryName = "";
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetAddressPermanent() {
      return this.$API
        .get(this.$PermanentAddress, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.AddressId = this.info.Id;
            this.Address1 = this.info.Address1.toUpperCase();
            this.Address2 = this.info.Address2.toUpperCase();
            this.Address3 = this.info.Address3.toUpperCase();
            this.Postcode = this.info.Postcode.toUpperCase();
            this.CityId = this.info.CityId;
            this.CityName = this.info.CityName.toUpperCase();
            this.StateId = this.info.StateId;
            this.StateName = this.info.StateName.toUpperCase();
            this.OtherStateName = this.info.OtherStateName.toUpperCase();
            this.CountryId = this.info.CountryId;
            this.CountryName = this.info.CountryName.toUpperCase();

            if (this.AddressId == null) this.AddressId = 0;
            if (this.Address1 == null) this.Address1 = "";
            if (this.Address2 == null) this.Address2 = "";
            if (this.Address3 == null) this.Address3 = "";
            if (this.Postcode == null) this.Postcode = "";
            if (this.CityName == null) this.CityName = "";
            if (this.StateName == null) this.StateName = "";
            if (this.OtherStateName == null) this.OtherStateName = "";
            if (this.CountryName == null) this.CountryName = "";
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetAddressMail() {
      return this.$API
        .get(this.$MailAddress, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.MailAddressId = this.info.Id;
            this.MailAddress1 = null != this.info.Address1 ? this.info.Address1.toUpperCase() : this.info.Address1;
            this.MailAddress2 = null != this.info.Address2 ? this.info.Address2.toUpperCase() : this.info.Address2;
            this.MailAddress3 = null != this.info.Address3 ? this.info.Address3.toUpperCase() : this.info.Address3;
            this.MailPostcode = this.info.Postcode;
            this.MailCityId = this.info.CityId;
            this.MailCityName = null != this.info.CityName ? this.info.CityName.toUpperCase() : this.info.CityName;
            this.MailStateId = this.info.StateId;
            this.MailStateName = null != this.info.StateName ? this.info.StateName.toUpperCase() : this.info.StateName;
            this.MailOtherStateName = null != this.info.OtherStateName ? this.info.OtherStateName.toUpperCase() : this.info.OtherStateName;
            this.MailCountryId = this.info.CountryId;
            this.MailCountryName = null != this.info.CountryName ? this.info.CountryName.toUpperCase() : this.info.CountryName;

            if (this.MailAddressId == null) this.MailAddressId = 0;
            if (this.MailAddress1 == null) this.MailAddress1 = "";
            if (this.MailAddress2 == null) this.MailAddress2 = "";
            if (this.MailAddress3 == null) this.MailAddress3 = "";
            if (this.MailPostcode == null) this.MailPostcode = "";
            if (this.MailCityName == null) this.MailCityName = "";
            if (this.MailStateName == null) this.MailStateName = "";
            if (this.MailOtherStateName == null) this.MailOtherStateName = "";
            if (this.MailCountryName == null) this.MailCountryName = "";
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetContactDetails() {
      var url = {};

      if (this.others == "applicant") url = this.$ContactDetails;
      else url = this.$ContactDetails + "/" + this.others;
      return this.$API
        .get(url, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.Email = this.info.Email;
            this.FixPhoneNo = this.info.FixPhoneNo;
            this.MobilePhoneNo = this.info.MobilePhoneNo;
            this.FaxNo = this.info.FaxNo;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    /*CM#4 address 1 & address 2 are mandatory*/
    InsertAddress() {
      var address1 = this.$store.getters["addressBook/Address1"];
      var address2 = this.$store.getters["addressBook/Address2"];
      var errMsg = "Sila isikan Alamat Baris 1 & Baris 2";
      if (address1.length > 0 && address2.length > 0) {
        this.Error = false;
        const formData = new FormData();
        formData.append("Address1", this.$store.getters["addressBook/Address1"]);
        formData.append("Address2", this.$store.getters["addressBook/Address2"]);
        formData.append("Address3", this.$store.getters["addressBook/Address3"]);
        formData.append("Postcode", this.$store.getters["addressBook/Postcode"]);
        formData.append("CityId", this.$store.getters["addressBook/CityId"]);
        formData.append("StateId", this.$store.getters["addressBook/StateId"]);
        formData.append(
          "CountryId",
          this.$store.getters["addressBook/CountryId"]
        );
        formData.append(
          "OtherStateName",
          this.$store.getters["addressBook/OtherStateName"]
        );

        return this.$API
          .post(this.$InsertAddress, formData, { withCredentials: true })
          .then((response) => {
            this.info = response.data;
            var newId = this.info;

            if (response.status == 200) {
              if (this.others == "applicant") {
                if (this.type == "permanent") {
                  this.AddressId = newId;
                } else this.MailAddressId = newId;
              } else {
                this.AddressId = newId;
              }

              return this.$API
                .get(
                  this.$UpdateAddress +
                  "/" +
                  this.others +
                  "/" +
                  this.type +
                  "/" +
                  newId,
                  { withCredentials: true }
                )
                .then((response) => {
                  if (response.status == 200) {
                    // Reload addresses displayed
                    if (this.others == "applicant") {
                      if (this.type == "permanent") {
                        this.GetAddressPermanent();
                      } else this.GetAddressMail();
                    } else {
                      this.GetAddressPersonal(this.others);
                    }
                    this.addAddressModal = false;
                    console.log("Address Added");
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else console.log("Error Adding.");
          })
          .catch((error) => {
            console.log(error);
            console.log(error);
            this.Loading = false;
          });
      } else { alert(errMsg) }
    },
    UpdateAddress() {
      var errMsg = "Sila isikan Alamat Baris 1 & Baris 2";
      var address1 = this.$store.getters["addressBook/Address1"];
      var address2 = this.$store.getters["addressBook/Address2"];
      if (address1.length > 0 && address2.length > 0) {
        const formData = new FormData();

        formData.append("Id", this.$store.getters["addressBook/Id"]);
        formData.append("Address1", this.$store.getters["addressBook/Address1"]);
        formData.append("Address2", this.$store.getters["addressBook/Address2"]);
        formData.append("Address3", this.$store.getters["addressBook/Address3"]);
        formData.append("Postcode", this.$store.getters["addressBook/Postcode"]);
        formData.append("CityId", this.$store.getters["addressBook/CityId"]);
        formData.append("StateId", this.$store.getters["addressBook/StateId"]);
        formData.append(
          "CountryId",
          this.$store.getters["addressBook/CountryId"]
        );
        formData.append(
          "OtherStateName",
          this.$store.getters["addressBook/OtherStateName"]
        );

        return this.$API
          .post(this.$UpdateAddress, formData, { withCredentials: true })
          .then((response) => {
            this.info = response.data;

            if (response.status == 200) {
              // Reload addresses displayed
              if (this.others == "applicant") {
                this.GetAddressPermanent();
                this.GetAddressMail();
              } else {
                this.GetAddressPersonal(this.others);
              }

              this.editAddressModal = false;
              console.log("Saved");
            } else console.log("Error Saving");
          })
          .catch((error) => {
            console.log(error);
          });
      } else { alert(errMsg) }
    },
    /*CM#4 address 1 & address 2 are mandatory*/
    ChangeAddress() {
      var url =
        this.$UpdateAddress +
        "/" +
        this.others +
        "/" +
        this.type +
        "/" +
        this.SelectedId;

      return this.$API
        .get(url, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            // Reload addresses displayed
            if (this.others == "applicant") {
              if (this.type == "permanent") {
                this.AddressId = this.SelectedId;
              } else this.MailAddressId = this.SelectedId;

              this.GetAddressPermanent();
              this.GetAddressMail();
            } else {
              if (this.type == "personal") {
                this.AddressId = this.SelectedId;
              }
              this.GetAddressPersonal(this.others);
            }
            this.chooseAddressModal = false;
            console.log("Address changed");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SetTypePermanent() {
      this.type = "permanent";
      this.addAddressModal = true;
    },
    SetTypeMail() {
      this.type = "mail";
      this.addAddressModal = true;
    },
    SetTypePersonal() {
      this.type = "personal";
      this.addAddressModal = true;
    },
    GetDetails() {
      this.$API
        .get(this.$PersonalDetails + "/guardian", {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.RelationshipId = this.info.RelationshipId;
            this.FirstName = this.info.FirstName;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    replaceDash() {
      let fN = 'replaceDash: ';
      this.FixPhoneNo = this.FixPhoneNo.replace("-","");
      this.MobilePhoneNo = this.MobilePhoneNo.replace("-","");
    }
  },
};
</script>
